import { InjectionToken } from '@angular/core';

import { EmailTemplateRendererComponent } from '../components/email-template-renderer/email-template-renderer.component';

export const TemplateComponentClass = new InjectionToken<any>('Template Component');
export const TemplateDataMock = new InjectionToken<Array<Record<string, any>>>('Template Schema');

export const provideTemplateDefinition = (name: string, component: any, mocks: any) =>
  mocks.map((mock: any, index: number) => ({
    name,
    render: index === 0,
    path: `${name}/${index === 0 ? 'reference' : index}`,
    providers: [
      { provide: TemplateComponentClass, useValue: component },
      { provide: TemplateDataMock, useValue: mock },
    ],
    component: EmailTemplateRendererComponent,
  }));
